<template>
	<fieldset>
		<slot name="legend"></slot>
		<v-text-field ref="cashDeposit"
			label="Cash deposit"
			readonly
			disabled
			v-show="!cashDeposit"
			:value="cashDeposit"
			:rules="[v => !!v]"
		></v-text-field>
		<slot name="before"></slot>
		<v-text-field ref="cardHolderName"
			name="cardHolderName"
			label="Card Holder Name"
			v-model="form.cardHolderName.value"
			data-hj-masked
			:success="form.cardHolderName.isValid"
			:rules="[v => !!v]"
			@input="handleNameInput"
			@focus="$emit('focus', 'card holder name')"
			@blur="handleCardHolderNameBlur"
		></v-text-field>
		<v-text-field ref="cardHidden"
			type="hidden"
			v-show="false"
			v-model="form.card.isValid"
			:rules="[v => v]"
		></v-text-field>
		<v-input ref="cardNumber" 
			class="v-text-field mt-3"
			:error-messages="error"
			:success="form.card.isValid"
		>
			<div ref="stripeSingleField"
				class="py-2"
				style="flex: 0 0 100%;" 
			></div>
		</v-input>
		<slot name="after"></slot>
		<v-row align="center">
			<v-col cols="12" class="text-sm-left text-center" style="font-size:14px;">
					<img :src="require('@/assets/icon-lock.svg')" 
						style="vertical-align:top;"
						height="23" 
						role="presentation"
					/><span v-html="'&nbsp;'"></span>
					Securely processed by Stripe
			</v-col>
		</v-row>
	</fieldset>
</template>
<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Validation from '../../mixins/validation';
import Analytics from '../../mixins/analytics';
export default Vue.extend({
	name: 'PayForm',
	props: ['disabled', 'value', 'cashDeposit'],
	data: function(){
		return {
			error: '', 
			form: {
				cardHolderName: {
					value: '', 
					isValid: false
				},
				card: {
					isValid: false
				}
			}
		};
	},
	methods: {
		handleNameInput(){
			this.form.cardHolderName.isValid = !!this.form.cardHolderName.value;
			this.emitValid();
		},
		handleCardHolderNameBlur() {
			this.$emit('blur', 'Card Holder Name');
		},
		setUpStripe(){
			const stripeKey = window.AppMode === 'app' ? 'pk_live_MUcqsoSmlCPIoAj6dDcUjgcf' : 'pk_test_UuozxLOI143lF53M1R03uT81';
			this.stripeInstance = window.Stripe(stripeKey);
			const elements = this.stripeInstance.elements({ fonts: [{
				family: 'ToyotaType',
				src: 'url(https://tdpasset.azureedge.net/acv97/fonts/global/toyota-type/ToyotaType-Regular.woff)',
				weight: '400',
			}]});
			const styles = {
				hidePostalCode: true, 
				style: {
					base: {
						lineHeight: 2,
						// height: '40px',
						fontSize: '18px', 
						fontFamily: 'ToyotaType, sans-serif', 
						color: '#1a1a1a', 
						'::placeholder': {
							color: '#666666'
						}
					}
				}
			};
			this.card = elements.create('card', styles);
			this.card.mount(this.$refs.stripeSingleField);
			this.card.addEventListener('focus', () => {
				this.$emit('focus', 'card number');
			});
			this.card.addEventListener('change', ({error, empty}) => {
				this.form.card.isValid = !error;
				if (error){
					this.$emit('blur', error.message);
					Validation.clog(error)
					this.error = error.message;
				}
				else {
					this.error = '';
				}
				this.emitValid();
			});
		},
		emitValid(){
			this.$emit('input', {
				stripeInstance: this.form.card.isValid ? this.stripeInstance : null, 
				card: this.form.card.isValid ? this.card : null, 
				name: this.form.card.isValid ? this.form.cardHolderName.value : ''
			});
		}
	}, 
	mounted(){
		this.setUpStripe();
	}
})
</script>
